
import axios from "axios";
import ConstantList from "app/appConfig";
import localStorageService from "app/services/localStorageService";
const API_PATH = ConstantList.API_ENPOINT + "/api/users/";
const API_PATH_ROLE = ConstantList.API_ENPOINT + "/api/roles/";
const API_NEW_PATH = ConstantList.API_ENPOINT + "/api/user/ext/";
const API_PATH_USER_ORGANIZATION = ConstantList.API_ENPOINT + "/api/user_health_organization/";
const API_PATH_USER_ADMINISTRATIVE_UNIT = ConstantList.API_ENPOINT + "/api/user-administrative-unit/";
const API_PATH_USER_ROLE_DETAIL = ConstantList.API_ENPOINT + "/api/user-role-detail/";

export const pagingUsers = (page, pageSize) => {
  var params = page + "/" + pageSize;
  var url = API_PATH + params;
  return axios.get(url);
};

export const findUserByUserName = (username, page, pageSize) => {
  var params = "username/" + username + "/" + page + "/" + pageSize;
  var url = API_PATH + params;
  return axios.get(url);
};
export const pagingNewUsers = (searchObject) => {
  var url = API_NEW_PATH + "pagingUsers";
  return axios.post(url, searchObject);
};

export const getAllRoles = () => {
  var url = API_PATH_ROLE + 'all';
  return axios.get(url);
};

export const getUser = id => {
  var url = API_PATH + id;
  return axios.get(url);
};


export const getUserByUsername = (username) => {
  const config = { params: { username: username} };
  var url = API_PATH;
  return axios.get(url, config);
};

export const getUserByEmail = (email) => {
  var params = "e/" + email;
  var url = API_PATH + params;
  return axios.get(url);
};

export const saveUser = user => {
  return axios.post(API_PATH, user);
};

export const deleteUser= id => {
  return axios.delete(API_NEW_PATH+"deleteById/" +id);
};
export const saveHealthOrganizations = (userId,healthOrganizations) => {
  var url = API_PATH_USER_ORGANIZATION + "save/"+userId;
  return axios.post(url, healthOrganizations);
};
export const getHealthOrganizationByUserId = userId => {
  var params = "get_healthorganization_by_userid/" + userId;
  var url = API_PATH_USER_ORGANIZATION + params;
  return axios.get(url);
};
export const deleteListUser= (listIds) => {
  var url = API_NEW_PATH + "deleteList";
  return axios.delete(url,listIds);
};
export const pagingUserHealthOrg = (searchObject) => {
  var url = API_PATH_USER_ORGANIZATION + "pagingUserHealthOrg";
  return axios.post(url, searchObject);
};
export const saveUserKeyCloak = user => {
  return axios.post(API_NEW_PATH+"createUserKeyCloak", user);
};
export const getCurrentUserName = () => {
  return axios.get(API_NEW_PATH + "get-current-user-name");
};

export const saveUserHealthOrganizations = (userId,userHealthOrg) => {
  var url = API_PATH_USER_ORGANIZATION + "saveList/"+userId;
  return axios.post(url, userHealthOrg);
};

export const getListUserHealthOrgByUserId = (userId) =>{
  var url = API_PATH_USER_ORGANIZATION + "getListUserHealthOrg/" + userId;
  return axios.get(url);
}

export const getCurrentUser = () => {
  return axios.get(API_NEW_PATH + "getCurrentUserName");
};

export const getListUserAdministrativeUnitByUserId = (userId) =>{
  var url = API_PATH_USER_ADMINISTRATIVE_UNIT + "get-list-user-administrative-unit/" + userId;
  return axios.get(url);
};

export const saveUserAdministrativeUnits = (userId,userHealthOrg) => {
  var url = API_PATH_USER_ADMINISTRATIVE_UNIT + "save-list/"+userId;
  return axios.post(url, userHealthOrg);
};
export const getListUserOrganization = () =>{
  var url = API_PATH_USER_ORGANIZATION + "get_healthorganization_dto_by_loginuser" ;
  return axios.get(url);
};
export const getListUserDepartment = () =>{
  var url = API_PATH_USER_ORGANIZATION + "get_health_department_dto_by_current_user" ;
  return axios.get(url);
};

const uninterceptedAxiosInstance = axios.create();
uninterceptedAxiosInstance.interceptors.request.use((config) => {
  config.headers.Authorization = `Bearer ${localStorageService.getItem("auth_token")}`;
  return Promise.resolve(config);
});
export const getNotification = (obj) => {
  const url = API_NEW_PATH + "getNotification"
  return uninterceptedAxiosInstance.post(url, obj);
};

export const countOnline = () => {
  return axios.get(API_NEW_PATH + "countOnline");
};

export const changePasswordSelf = user => {
    var url = API_NEW_PATH + "resetPassword/self";
  return axios.put(url, user);
};

export const changePassword = user => {
  var url = API_NEW_PATH + "change-password";
return axios.post(url, user);
};

export const resetPasswordUserKeyCloak = user => {
  var url = API_NEW_PATH + "resetPasswordUserKeyCloak";
return axios.post(url, user);
};

export const getListAdministrativeUnitByUser = () => {
  var url = API_PATH_USER_ADMINISTRATIVE_UNIT + "get-list-administrative-unit-by-user";
  return axios.get(url);
};

export const saveListUserRoleDetail = (id, list) => {
  const url = API_PATH_USER_ROLE_DETAIL + "save-list/" + id;
  return axios.post(url, list)
}

export const getListUserRoleDetail = id => {
  return axios.get(API_PATH_USER_ROLE_DETAIL + "get-list-user-role-detail/" + id)
}

export const updateUserKeyCloak = obj => {
  var url = API_NEW_PATH + "updateUserKeyCloak";
return axios.put(url, obj);
}